/*!

=========================================================
* Paper Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// import avatar from "assets/img/faces/ayo-ogunseinde-2.jpg";
import logo from "../../assets/img/logo_aotmit50.png";

import { logoutUser } from "actions/authActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";

var ps;

function Sidebar(props) {
    const location = useLocation();

    const logOut = () => {
        props.logoutUser();
    };
    const [collapseStates, setCollapseStates] = React.useState({});
    const sidebar = React.useRef();
    // this creates the intial state of this component based on the collapse routes
    // that it gets through props.routes
    const getCollapseStates = (routes) => {
        let initialState = {};
        routes.map((prop, key) => {
            if (prop.collapse) {
                initialState = {
                    [prop.state]: getCollapseInitialState(prop.views),
                    ...getCollapseStates(prop.views),
                    ...initialState,
                };
            }
            return null;
        });
        return initialState;
    };
    // this verifies if any of the collapses should be default opened on a rerender of this component
    // for example, on the refresh of the page,
    // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
    const getCollapseInitialState = (routes) => {
        for (let i = 0; i < routes.length; i++) {
            if (
                routes[i].collapse &&
                getCollapseInitialState(routes[i].views)
            ) {
                return true;
            } else if (
                window.location.pathname.indexOf(routes[i].path) !== -1
            ) {
                return true;
            }
        }
        return false;
    };
    // this function creates the links and collapses that appear in the sidebar (left menu)
    const createLinks = (routes) => {
        return (
            <>
                {" "}
                {routes.map((prop, key) => {
                    if (prop.redirect) {
                        return null;
                    }

                    if (prop.collapse) {
                        var st = {};
                        st[prop["state"]] = !collapseStates[prop.state];
                        return (
                            <li
                                className={
                                    getCollapseInitialState(prop.views)
                                        ? "active"
                                        : ""
                                }
                                key={key}
                            >
                                <a
                                    href="#"
                                    data-toggle="collapse"
                                    aria-expanded={collapseStates[prop.state]}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setCollapseStates(st);
                                    }}
                                >
                                    {prop.icon !== undefined ? (
                                        <div className="sidebarElementGrid align-items-left">
                                            <i
                                                className={prop.icon}
                                                style={{ color: "#266a64" }}
                                            />
                                            <p>
                                                {prop.name}
                                                {/*<b style={{display:"block"}} className="caret" />*/}
                                            </p>
                                            <b
                                                style={{ display: "block" }}
                                                className="caret"
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <span className="sidebar-mini-icon">
                                                {prop.mini}
                                            </span>
                                            <span className="sidebar-normal">
                                                {prop.name}
                                                <b className="caret" />
                                            </span>
                                        </>
                                    )}
                                </a>
                                <Collapse isOpen={collapseStates[prop.state]}>
                                    <ul className="nav">
                                        {createLinks(prop.views)}
                                    </ul>
                                </Collapse>
                            </li>
                        );
                    }
                    return (
                        <li
                            className={activeRoute(prop.layout + prop.path)}
                            key={key}
                        >
                            <NavLink
                                to={prop.layout + prop.path}
                            >
                                {prop.icon !== undefined ? (
                                    <span className="sidebarElementGrid">
                                        {/* className='sidebarElementGrid' */}
                                        <i
                                            style={{ color: "#266a64" }}
                                            className={prop.icon}
                                        />
                                        <p>{prop.name}</p>
                                    </span>
                                ) : (
                                    <div className="sidebarElementGrid align-items-left">
                                        <span className="sidebar-mini-icon">
                                            {prop.mini}
                                        </span>
                                        <span
                                            className="sidebar-normal"
                                            style={{ whiteSpace: "normal" }}
                                        >
                                            {prop.name}
                                        </span>
                                    </div>
                                )}
                            </NavLink>
                        </li>
                    );
                })}
                {routes.length > 4 && (
                    <li>
                        <NavLink to={"/"} onClick={logOut}>
                            <>
                                <i
                                    className="nc-icon nc-share-66"
                                    style={{
                                        color: "#266a64",
                                        transform: "rotate(90deg)",
                                    }}
                                ></i>
                                {/* <i className="fas fa-sign-out-alt" style={{color: '#32cbc1'}} /> */}
                                <p>Wyloguj</p>
                            </>
                        </NavLink>
                    </li>
                )}
            </>
        );
    };
    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName) => {
        return location.pathname.indexOf(routeName) > -1 ? "active" : "";
    };
    React.useEffect(() => {
        // if you are using a Windows Machine, the scrollbars will have a Mac look
        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar(sidebar.current, {
                suppressScrollX: true,
                suppressScrollY: false,
            });
        }
        return function cleanup() {
            // we need to destroy the false scrollbar when we navigate
            // to a page that doesn't have this component rendered
            if (navigator.platform.indexOf("Win") > -1) {
                ps.destroy();
            }
        };
    });
    React.useEffect(() => {
        setCollapseStates(getCollapseStates(props.routes));
        // eslint-disable-next-line
    }, []);
    const navigate = useNavigate();
    const goToMain = () => {
        navigate("/");
    };

    return (
        <div
            className={"sidebar" + (props.sm ? " sidebar-sm" : "")}
            data-color={props.bgColor}
            data-active-color={props.activeColor}
        >
            <div className="logo">
                <a tabIndex={'0'}
                   onClick={() => {
                       goToMain();
                       window.focus();
                       window.scrollTo(0, 0);
                   }}
                   onKeyDown={(e) => {
                       if (e.key === 'Enter') {
                           goToMain();
                       }
                   }}
                   className="simple-text logo-mini"
                   aria-label={'Przejdź na stronę główną'}
                   style={{
                       opacity: "100%",
                       cursor: "pointer",
                       marginLeft: "29%",
                   }}
                >
                    <div className="">
                        <img
                            className="imgLogoRender"
                            src={logo}
                            alt="aotmit-logo"
                        />
                    </div>
                </a>
                {/*<a
                    onClick={() => {
                        goToMain();
                        window.focus();
                        window.scrollTo(0, 0);
                    }}
                    style={{ cursor: "pointer" }}
                    className="simple-text logo-normal"
                ></a>*/}
                <br />
                <br />
                <br />{" "}
                <h1 className={'h5'} style={{ marginLeft: "28%", textTransform: "uppercase", fontSize: '14px', display: 'inline' }}>
                    APlikacja SRK
                </h1>
                <br></br>
            </div>

            <div className="sidebar-wrapper" ref={sidebar}>
                <Nav>{createLinks(props.routes)}</Nav>
            </div>
        </div>
    );
}

export default connect(null, { logoutUser })(Sidebar);
